import { render, staticRenderFns } from "./WebLinks.vue?vue&type=template&id=2b54df12&scoped=true"
import script from "./WebLinks.vue?vue&type=script&lang=js"
export * from "./WebLinks.vue?vue&type=script&lang=js"
import style0 from "./WebLinks.vue?vue&type=style&index=0&id=2b54df12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b54df12",
  null
  
)

export default component.exports